/**
 * Generated by orval v7.6.0 🍺
 * Do not edit manually.
 * API приложения MESone
 * Коллекция запросов API приложения

[Schema](/api/assets/swagger-docs/swagger.json)
 * OpenAPI spec version: 1.0.0
 */
import type {
  Login200,
  NavigationParams,
  Refresh200,
  UserAppSettingsResponse,
  UserLoginDto,
  UserNavigationResponse
} from '../rest-api.schemas';

import { customInstance } from '../../custom-axios-instance';
import type { BodyType } from '../../custom-axios-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * Возвращает токены авторизации
 * @summary Вход в систему
 */
export const login = (
    userLoginDto: BodyType<UserLoginDto>,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<Login200>(
      {url: `/v1/user/login`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: userLoginDto
    },
      options);
    }
  /**
 * Отменяет авторизацию пользователя.
 * @summary Выход из системы
 */
export const logout = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<void>(
      {url: `/v1/user/logout`, method: 'POST'
    },
      options);
    }
  /**
 * Возвращает токены авторизации
 * @summary Обновление токенов
 */
export const refresh = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<Refresh200>(
      {url: `/v1/user/refresh`, method: 'POST'
    },
      options);
    }
  /**
 * Получает структуру навигации меню для пользователя на основе роли и локали
                    из <Vault(system_db) schema>.tools и <Vault(system_db) schema>.folders.
                   В ответе присылает отсортированный список элементов.
 * @summary Получить структуру навигации для пользователя
 */
export const navigation = (
    params: NavigationParams,
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<UserNavigationResponse>(
      {url: `/v1/user/navigation`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Запрашивает настройки приложения из таблицы 
    <Vault(system_db): schema>.app_common_settings базы system_db без
     токена доступа исключая поля пустые поля.
 * @summary Запросить настройки приложения без токена доступа
 */
export const getUserAppSettings = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      return customInstance<UserAppSettingsResponse>(
      {url: `/v1/user/application/settings`, method: 'GET'
    },
      options);
    }
  
type AwaitedInput<T> = PromiseLike<T> | T;

    type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

export type LoginResult = NonNullable<Awaited<ReturnType<typeof login>>>
export type LogoutResult = NonNullable<Awaited<ReturnType<typeof logout>>>
export type RefreshResult = NonNullable<Awaited<ReturnType<typeof refresh>>>
export type NavigationResult = NonNullable<Awaited<ReturnType<typeof navigation>>>
export type GetUserAppSettingsResult = NonNullable<Awaited<ReturnType<typeof getUserAppSettings>>>
